import React, { FC } from "react";
import { useParams } from "react-router-dom";

import {
  useEmployeeSurveysSlideNavigation,
  useEmployeeSurveySubmissionForm,
  useRightSidebarState,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";
import {
  EmployeeSurveyDetail,
  EmployeeSurveySubmissionsCountCalendar,
} from "~/components/organisms";
import { NotFoundIndex } from "~/components/pages";

import { MyRoutes } from "~/config/Paths";

import { RightSidebarToggleIconWithLabel } from "~/ui";

export const MembersInputEmployeeSurveysShow: FC = () => {
  const { id = "" } = useParams<{ id: string }>();
  const query = new URLSearchParams(location.search);
  const businessSectionId = query.get("business_section_id") || "";
  const {
    searchCalendarOpenToggle,
    setCalendarOpen,
    isOpen,
    isCalendarOpen,
    currentOpenLabel,
  } = useRightSidebarState("isCalendarOpen");
  const {
    employeeSurvey,
    isError,
    shareable,
    answers,
    isCreating,
    postDate,
    onChangePostDate,
    onChangeShareable,
    onChangeAnswer,
    handleSubmit,
  } = useEmployeeSurveySubmissionForm({
    employeeSurveyId: id,
  });

  const { navigations } = useEmployeeSurveysSlideNavigation({
    businessSectionId,
    selectedArray: [true, false],
  });

  const breadCrumbItems = [
    {
      label: "チェックアウト",
      href: MyRoutes.Members.inputEmployeeSurveysIndex({
        q: { business_section_id: businessSectionId },
      }),
    },
    {
      label: "入力",
      href: MyRoutes.Members.inputEmployeeSurveysIndex({
        q: { business_section_id: businessSectionId },
      }),
    },
  ];

  if (isError) return <NotFoundIndex />;

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent navigations={navigations} withRightSidebar>
        {employeeSurvey && (
          <EmployeeSurveyDetail
            employeeSurvey={employeeSurvey}
            shareable={shareable}
            onChangeShareable={onChangeShareable}
            answers={answers}
            onChangeAnswer={onChangeAnswer}
            handleSubmit={handleSubmit}
            isSubmitting={isCreating}
            postDate={postDate}
            onChangePostDate={onChangePostDate}
            className="mt-6"
          />
        )}
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar>
        <RightSidebarToggleIconWithLabel
          iconOnClick={searchCalendarOpenToggle}
          handleOnClose={isCalendarOpen ? undefined : setCalendarOpen}
          label={currentOpenLabel}
          isOpen={isOpen}
        >
          {isCalendarOpen && (
            <EmployeeSurveySubmissionsCountCalendar className="mt-6" />
          )}
        </RightSidebarToggleIconWithLabel>
      </EmployeeLayoutRightSidebar>
    </EmployeeLayout>
  );
};
